var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "is-relative",
      staticStyle: { height: "100%", width: "100%", "object-fit": "contain" },
    },
    [
      !_vm.isLoaded
        ? _c("div", {
            staticClass: "loading-image",
            staticStyle: {
              height: "100%",
              width: "100%",
              "object-fit": "contain",
            },
          })
        : _vm._e(),
      _c("img", {
        staticStyle: { height: "100%", width: "100%", "object-fit": "contain" },
        attrs: { src: _vm.src },
        on: {
          load: function ($event) {
            return _vm.setLoading(false)
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }